import {useEffect, useState} from "react";
import {isNullOrUndefined} from "../../services/Validator";
import {
    computePictureUrl,
} from "../../controllers/flashScreens/questionsStepScreen/QuestionPictureController";
import SystemKnowledgeExamplePictureError from "../errors/SystemKnowledgeExamplePictureError";
import SystemKnowledgeExamplePictureLoader from "../loaders/SystemKnowledgeExamplePictureLoader";

export default function SystemKnowledgeExamplePicture({pictureUrl}) {
    // Used in FlashQuestionContent to display
    // question related image

    // PROPERTIES
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [src, setSrc] = useState(null)

    // HOOKS
    useEffect(() => {
        if (!isNullOrUndefined(pictureUrl)) {
            // Switch loader on and clear potential error
            setIsLoading(true)
            setHasError(false)
            // Prepare
            const url = computePictureUrl(pictureUrl)
            // Execute
            fetch(url).then((res) => {
                res.blob().then((res) => {
                    setSrc(URL.createObjectURL(res))
                }).catch((err) => {
                    console.log(err)
                    setHasError(true)
                })
            }).catch((err) => {
                console.log(err)
                setHasError(true)
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }, [pictureUrl])

    // BUILD
    if (isNullOrUndefined(pictureUrl))
        return null
    if (hasError)
        return <SystemKnowledgeExamplePictureError />
    if (isLoading)
        return <SystemKnowledgeExamplePictureLoader />
    return (
        <div className={`w-full animate-appear relative overflow-hidden rounded-[8px] mt-[12px]`}>
            <img src={src}
                 alt="Illustration exemple type"
                 className={`object-cover w-full`}
                 onError={() => setHasError(true)}
                 onLoad={() => setHasError(false)} />
        </div>
    );
}